/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
function fadeOut(el) {
	var opacity = 1;
	var timer = setInterval(function() {
		if (opacity <= 0.1) {
			clearInterval(timer);
			document.querySelector(el).style.display = "none";
		}
		document.querySelector(el).style.opacity = opacity;
		opacity -= opacity * 0.1;

	}, 10);
}

function fadeIn(el) {
	var opacity = 0.01;
	document.querySelector(el).style.display = "block";
	var timer = setInterval(function() {
		if (opacity >= 1) {
			clearInterval(timer);
		}
		document.querySelector(el).style.opacity = opacity;
		opacity += opacity * 0.1;
	}, 10);
}

/***************************************************
 * Handle the sticky header on desktop and mobile
 ***************************************************/
// Assign the latest postion based on top pixels
var lastScrollTop = $(window).scrollTop();

function handleHeaderAnimation() {
  // Elements
  var body = $('body');
  var announcementBar = $('.AnnouncementBar__Wrapper');
  var header = $('#section-header'); // Set values

  var currentScrollTop = $(window).scrollTop();
  var announcementBarIsActive = announcementBar.hasClass('.closed');
  var isMobile = $(window).width() < 768;
  var offset = 0; // Set offset based on announcement bar

  if (announcementBarIsActive) {
    offset = 0;
  } else {
    offset = 32;
  }

  // Toggle mobile classes
  if (currentScrollTop < (lastScrollTop - 10) && isMobile) {
    // Scrolling up
    /*
    body.addClass('header-scrolled-mobile');
    body.addClass('header-scrolled-mobile-visible');
    
    console.log ('currentScrollTop =' + currentScrollTop );
    console.log ('lastScrollTop =' + lastScrollTop );
    console.log ('isMobile =' + isMobile );
    
    */
  } else if (currentScrollTop > lastScrollTop && isMobile) {
    // Scrolling down
    //body.addClass('header-scrolled-mobile');
    //body.removeClass('header-scrolled-mobile-visible');
    body.addClass('header-scrolled-down');
  } else {
    // Reset
    //body.removeClass('header-scrolled-mobile');
    //body.removeClass('header-scrolled-mobile-visible');
    body.removeClass('header-scrolled-down');
  }
  // Toggle class when scrolled past offset
  if (currentScrollTop > offset) {
    body.addClass('header-scrolled');
  } else {
    body.removeClass('header-scrolled');
  }
  // Assign the currentScrollTop to lastScrollTop
  lastScrollTop = currentScrollTop;
}
// Do this directly after page refreshed/loaded
handleHeaderAnimation();

$(window).on('scroll', function (event) {
  handleHeaderAnimation();
});
/***************************************************
 * Collection scripts
 ***************************************************/